import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initScrollTo from './utilities/scroll-to';
import initPinned from './utilities/pinned';

import initHeader from './components/header';
import initMenu from './components/menu';
import initCookies from './components/cookies';
import initCarousels from './components/carousels';
import initProjectScroll from './components/project-scroll';
import initBackLink from './components/back-link';

// Init cookie plugin if not home page, which is done in home.js
if (document.body.dataset.page !== 'home') {
    initCookies();
}

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const scrollToEls = document.querySelectorAll('.js-scroll-to');

if (scrollToEls && scrollToEls.length > 0) {
    initScrollTo(scrollToEls);
}

const pinnedEls = document.querySelectorAll('.js-pinned');

if (pinnedEls && pinnedEls.length > 0) {
    initPinned(pinnedEls);
}

const headerEl = document.querySelector('.js-header');
let header;

if (headerEl) {
    header = initHeader(headerEl);
}

const menuEl = document.querySelector('.js-menu-toggle');

if (menuEl) {
    initMenu(menuEl, header);
}

const carouselEls = document.querySelectorAll('.js-carousel');

if (carouselEls && carouselEls.length > 0) {
    initCarousels(carouselEls);
}

const scrollEl = document.querySelector('.js-project-scroll');

if (scrollEl) {
    initProjectScroll(scrollEl);
}

const backLinkEl = document.querySelector('.js-back-link');

if (backLinkEl) {
    initBackLink(backLinkEl);
}
